import { supabase } from '@/lib/supabase';

export type PortfolioAgreement = {
  id: string;
  title: string;
  completed_at: string;
  status: string;
  rating: number | null;
  tags?: string[];
  comment?: string | null;
};

export type BusinessMemberSummary = { id: string; full_name: string | null; avatar_url: string | null };

export type Portfolio = {
  enabled: boolean;
  public: boolean;
  specialty: string | null;
  completed_count: number;
  total_count: number;
  completion_rate: number;
  avg_rating: number | null;
  agreements: PortfolioAgreement[];
  business_id?: string | null;
  business_name?: string | null;
  business_members?: BusinessMemberSummary[];
  /** Πλήθος συνεταίρων που ΔΕΝ εμφανίζονται στο business_members επειδή το
   * δικό τους προφίλ είναι ιδιωτικό — για ανώνυμη ένδειξη "και N συνέταιρος". */
  hidden_member_count?: number;
  business_address?: string | null;
  business_city?: string | null;
  business_postal_code?: string | null;
  eshop_url?: string | null;
};

type PortfolioRpcResult = Partial<Portfolio> & { enabled: boolean };

export async function getPortfolio(userId: string, { preview = false } = {}): Promise<Portfolio | null> {
  const { data: raw, error } = await supabase.rpc('get_portfolio', { p_user_id: userId });
  if (error) throw error;
  const data = raw as PortfolioRpcResult | null;

  // Fallback: αν το RPC επέστρεψε null ή enabled=false, ελέγχουμε απευθείας το profiles.portfolio_enabled
  if (!data || !data.enabled) {
    const { data: profileRows } = await supabase.rpc('get_profiles_public', { p_ids: [userId] });
    const profileRow = profileRows?.[0] ?? null;

    const actuallyEnabled = profileRow?.portfolio_enabled === true;
    if (!actuallyEnabled) return null;
    if (!preview && profileRow?.portfolio_public === false) return null;

    // portfolio_enabled=true αλλά το RPC επέστρεψε λάθος — επιστρέφουμε minimal object
    return {
      enabled: true,
      public: profileRow?.portfolio_public ?? true,
      specialty: null,
      completed_count: 0,
      total_count: 0,
      completion_rate: 0,
      avg_rating: null,
      ...(data ?? {}),
      agreements: Array.isArray(data?.agreements) ? data.agreements : [],
    } as Portfolio;
  }

  if (!preview && !data.enabled) return null;
  return data as Portfolio;
}
